import React from "react";

export const FileIconSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    // fill="currentColor"
  >
    <path d="M14 2H6C4.9 2 4 2.9 4 4v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm1 7V3.5L18.5 9H15zM8 9h4c.6 0 1 .4 1 1v.5c0 .6-.4 1-1 1H8c-.6 0-1-.4-1-1V10c0-.6.4-1 1-1zm0 4h4c.6 0 1 .4 1 1v.5c0 .6-.4 1-1 1H8c-.6 0-1-.4-1-1V14c0-.6.4-1 1-1zm8 4H8c-.6 0-1-.4-1-1v-.5c0-.6.4-1 1-1h8c.6 0 1 .4 1 1V16c0 .6-.4 1-1 1z" />
  </svg>
);
